import 'css-chunksrc/client/scenes/projectExpenseCreation/form/elementAttachmentsUpload/styles.scss';export default {
  "attachmentsButton": "_attachmentsButton_14gd5_1",
  "dropzone": "_dropzone_14gd5_21",
  "dropPreview": "_dropPreview_14gd5_28",
  "dropPreviewMessage": "_dropPreviewMessage_14gd5_40"
};